import PageHeader from '../components/PageHeader.jsx';
import { useAuth } from '../contexts/AuthContext.jsx';
import { useToast } from '../contexts/ToastContext.jsx';
import { useNotifications } from '../contexts/NotificationContext.jsx';

export default function Settings() {
  const { user, device, logout } = useAuth();
  const toast = useToast();
  const { permission, requestPermission } = useNotifications();

  const testNotification = () => {
    if (permission !== 'granted') {
      toast.error('Notification permission not granted');
      return;
    }
    toast.info('This is a test toast', 'Test Notification');
    new Notification('📷 Test Notification', {
      body: 'This is a test notification from SyncVault.',
      icon: 'https://x9ogt2f8d1hnsynj.public.blob.vercel-storage.com/Syncvault/icon.png'
    });
  };

  return (
    <div>
      <PageHeader title="Settings" subtitle="Account, retention, and integrations." />

      <section className="card mb-4">
        <h2 className="mb-2 text-sm font-semibold uppercase text-zinc-400">Profile</h2>
        <dl className="grid grid-cols-1 gap-2 text-sm sm:grid-cols-2">
          <div><dt className="label">Username</dt><dd>{user?.username}</dd></div>
          <div><dt className="label">Role</dt><dd><span className="chip">{user?.role}</span></dd></div>
          <div><dt className="label">Current device</dt><dd>{device?.device_name || 'unknown'}</dd></div>
          <div><dt className="label">Device type</dt><dd>{device?.device_type || device?.platform || 'unknown'}</dd></div>
        </dl>
      </section>

      <section className="card mb-4">
        <h2 className="mb-2 text-sm font-semibold uppercase text-zinc-400">Notifications</h2>
        <div className="flex flex-col gap-4">
          <div className="flex items-center justify-between gap-4">
            <div className="text-sm text-zinc-300">
              <p>Browser notifications for new clipboard entries and snapshots.</p>
              <p className="mt-1 text-xs text-zinc-500">
                Current status: <span className="font-mono">{permission}</span>
              </p>
            </div>
            {permission !== 'granted' && (
              <button className="btn-secondary" onClick={requestPermission}>
                Enable
              </button>
            )}
            {permission === 'granted' && (
              <div className="text-emerald-500 text-xs font-semibold">ACTIVE</div>
            )}
          </div>
          <button className="btn-ghost w-fit" onClick={testNotification}>
            Send Test Notification
          </button>
        </div>
      </section>

      <section className="card mb-4">
        <h2 className="mb-2 text-sm font-semibold uppercase text-zinc-400">Retention</h2>
        <p className="text-sm text-zinc-300">Clips and snaps are stored in temporary Cloudflare R2 storage for 24 hours, then archived to permanent R2 storage. Metadata stays in D1 forever so you can still search history.</p>
      </section>

      <section className="card mb-4">
        <h2 className="mb-2 text-sm font-semibold uppercase text-zinc-400">Security</h2>
        <ul className="list-disc space-y-1 pl-5 text-sm text-zinc-300">
          <li>Passwords hashed with PBKDF2-SHA256 (100k iterations).</li>
          <li>JWT access tokens (24h) and refresh tokens (30d).</li>
          <li>All traffic forced over HTTPS at the edge.</li>
          <li>End-to-end encryption is on the v2 roadmap.</li>
        </ul>
      </section>

      <section className="card">
        <h2 className="mb-2 text-sm font-semibold uppercase text-zinc-400">Session</h2>
        <button className="btn-danger" onClick={async () => { await logout(); toast.info('Signed out'); }}>Sign out</button>
      </section>
    </div>
  );
}
